export const convertToSeconds = (hours, minutes) => {
  const h = parseInt(hours, 10) || 0;
  const m = parseInt(minutes, 10) || 0;
  return h * 3600 + m * 60;
};

export const getHoursFromSeconds = (seconds) => {
  const secondsInt = parseInt(seconds, 10) || 0;
  const hours = Math.floor(secondsInt / 3600);
  return hours.toString();
};

export const getMinutesFromSeconds = (seconds) => {
  const secondsInt = parseInt(seconds, 10) || 0;
  const minutes = Math.floor((secondsInt % 3600) / 60);
  return minutes.toString().padStart(2, '0');
};
